import type { AppOverlayView } from './AppOverlayView';
import { PopupStackController } from '../../popups/PopupStackController';
import type { App } from '../App';

export class AppOverlayController {
  public readonly popups: PopupStackController;

  constructor(
    public readonly app: App,
    public readonly view: AppOverlayView,
  ) {
    this.popups = new PopupStackController(this.app, view.popups);
  }

  public update(deltaTime: number): void {
    this.view.update(deltaTime);
    this.popups.update(deltaTime);
  }
}
